import React, { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Button,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Typography
} from '@material-ui/core';

import TableEditBar from '../../../../components/TableEditBar/TableEditBar';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditShowroomOperator from '../../../EditShowroomOperator/EditShowroomOperator';

const useStyles = makeStyles(theme => ({
    root: {},

    content: {
        padding: 0
    },

    inner: {
        minWidth: 700
    },

    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },

    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },

    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    }

}));

export default function TableList(props) {

    const { className, showrooms, ...rest } = props;
    const classes = useStyles();

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
            >
                {/* {showrooms.length} Records found. Page {page + 1} of{' '}
            {Math.ceil(showrooms.length / rowsPerPage)} */}
            </Typography>
            <Card>
                <CardHeader
                    //   action={<GenericMoreButton />}
                    title="Showrooms"
                />
                <Divider />
                <CardContent className={classes.content}>
                        <div className={classes.inner + "  data_list_container"}>
                            {showrooms.map(showroom => (
                                <div className="data_list_view">
                                    <div className="info">
                                        <h3>
                                        <span style={{
                                                        width: 14,
                                                        height: 14,
                                                        borderRadius: 7,
                                                        marginRight: 10,
                                                        position: "relative",
                                                        top: 2,
                                                        display: 'inline-block',
                                                        backgroundColor: showroom.color
                                                    }}></span> 
                                            {showroom.name}</h3>
                                        <p>
                                            {showroom.description}</p>

                                    </div>
                                    <div className="actions">
                                        <div className="button_wrapper">
                                            <RouterLink
                                                to={"/showroom/detailshowroom/" + showroom.property_id}
                                            >
                                                <Button   // to={"/showroom/detailshowroom/" + showroom.property_id}
                                                    className="list_button"
                                                    variant="outlined"
                                                >

                                                    <VisibilityIcon
                                                    ></VisibilityIcon>
                                                </Button>

                                            </RouterLink>


                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                </CardContent>

            </Card>
        </div>
    );


}